'use strict';

var EmployerMatchTable = function(p) {
	this.p = p;
};

EmployerMatchTable.prototype.findMatchTable = function(increment) {
	increment = typeof increment === 'undefined' ? 0 : increment;

	var client = this.p.model.client;
	var match = this.p.employerMatch[client];
	
	if (!match) {
		if (this.p.employerMatch.default) {
			match = this.p.employerMatch.default;
		} else {
			match = this.p.employerMatch;
		}
	}
	
	var keys = Object.keys(match).sort(function(a, b) {
		return a - b;
	});
	var key = keys[0];
	
	var serviceValue = this.p.model.serviceValue;
	var matcher = (serviceValue === false ? this.p.calculationAge() : serviceValue) + increment;

	if (+matcher > +keys[keys.length - 1]) {
		throw new Error('No upper bound match found');
	}

	if (keys.length > 1) {
		for (var i = 0; i < keys.length; i++) {
			var k = keys[i];

			if (matcher <= k) {
				key = k;
				break;
			}
		}
	}
	
	return match[key];
};

EmployerMatchTable.prototype.getEmployeeMatch = function(increment) {
	var table = this.findMatchTable(increment);

	// This is for eeErsIncludeScale is true and we need to add on the matched employee contribution on to parameter contribution passed through
	return table.employee[0];
};

EmployerMatchTable.prototype.getMatch = function(employeeRate, increment) {
	var table = this.findMatchTable(increment);

	//no matching scale present
	if(table.employer.length === 0) {
		return 0;
	}

	//employee paying less than the matched minimum
	if(employeeRate < table.employee[0]) {
		return 0;
	}

	//employee paying more than the matched maximum
	if(employeeRate > table.employee[table.employee.length - 1]) {
		return table.employer[table.employer.length - 1];
	}
	
	//find employer match
	for(var i = 0; i < table.employee.length; i++) {
		if(employeeRate <= table.employee[i]) {
			return table.employer[i];
		}
	}
};

//Node module export
if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = EmployerMatchTable;
    }
    exports.EmployerMatchTable = EmployerMatchTable;
}